import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import tooltips from '../../../../tooltips.json';
import TooltipWarning from '../../../../components/TooltipWarning';
import { getAlgoListDataCachedSelectedDay } from '../../../../stores/algos-list/getters';
import BrokerDisabledWarning from '../../../../components/BrokerDisabledWarning';
import useBrokerDataAll from '../../../../hooks/useBrokerDataAll';
import { getIsBrokersOk, getIsBrokersFetching } from '../../../../reducers';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& .tooltip-box': {
      marginRight: 5,

      '&:last-child': {
        marginRight: 0,
      },
    },
  },
}));

const CellAlerts = ({ row = {} }) => {
  const classes = useStyles();
  const { original = {} } = row;

  const brokersDataAll = useBrokerDataAll();

  const isMountedSetupBrokers = useSelector(getIsBrokersOk);
  const isFetchingSetupBrokers = useSelector(getIsBrokersFetching);

  const { _id = '', stoplossTrailing = false } = original;

  const broker = useSelector((state) => {
    const { broker = '' } =
      getAlgoListDataCachedSelectedDay(state).find((d) => d._id === _id) || {};

    return broker;
  });

  const hasError = useSelector((state) => {
    const { hasError = false } =
      getAlgoListDataCachedSelectedDay(state).find((d) => d._id === _id) || {};

    return hasError;
  });

  const hasWaitingWT = useSelector((state) => {
    const { hasWaitingWT = false } =
      getAlgoListDataCachedSelectedDay(state).find((d) => d._id === _id) || {};

    return hasWaitingWT;
  });

  return (
    <div className={classes.root}>
      {isMountedSetupBrokers &&
      !isFetchingSetupBrokers &&
      brokersDataAll &&
      brokersDataAll.length ? (
        <BrokerDisabledWarning
          options={brokersDataAll}
          value={broker}
          className="disabled-warning"
        />
      ) : (
        ''
      )}

      {stoplossTrailing && (
        <TooltipWarning
          title={tooltips['stoplossTrailing']}
          className="tooltip-box"
          color="#fd6900"
        />
      )}

      {hasError && (
        <TooltipWarning
          title="Error in one or more positions"
          className="tooltip-box"
          color="var(--color-error-tooltip)"
        />
      )}

      {hasWaitingWT && (
        <TooltipWarning
          title="Waiting"
          className="tooltip-box"
          color="var(--color-colorPrimary-main)"
        />
      )}
    </div>
  );
};

export default CellAlerts;
